<template>
	<el-dialog title="提示" :visible.sync="visible" :before-close="beforeClose" width="600px">
		<div class="pt-12 pl-12">
			<p class="font-h4-regular yx-color-text-primary">
				商家要求协作样品的
				<span class="yx-color-warning">“审核+发货”</span>
				环节，请先修改团队设置:
			</p>
			<div class="font-h4-regular yx-color-text-primary mt-24">
				<i v-if="sampleRule" class="el-icon-success yx-color-success fz-16"></i>
				<i v-else class="el-icon-error yx-color-danger fz-16"></i>
				<span class="ml-8">样品订单开启【待审核】状态</span>
			</div>
			<div class="font-h4-regular yx-color-text-primary mt-16 flex-row-align-center flex-just-between">
				<p>
					<i v-if="cooperateRule" class="el-icon-success yx-color-success fz-16"></i>
					<i v-else class="el-icon-error yx-color-danger fz-16"></i>
					<span class="ml-8">协作规则-自动同步申请选择【审核+发货】</span>
				</p>
				<p class="yx-color-primary font-h4-regular" @click="skipUrl">
					<span>去修改</span>
					<i class="el-icon-arrow-right"></i>
				</p>
			</div>
		</div>
		<div slot="footer" class="footer-dialog">
			<el-button type="primary" @click="confirm">我知道了</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
			sampleRule: true,
			cooperateRule: true,
		};
	},
	methods: {
		show(sampleRule, cooperateRule) {
			this.sampleRule = sampleRule;
			this.cooperateRule = cooperateRule;
			this.visible = true;
		},
		async confirm() {
			this.beforeClose();
		},
		beforeClose() {
			this.sampleRule = true;
			this.cooperateRule = true;
			this.visible = false;
		},
		skipUrl() {
			const handLink = this.$router.resolve({
				path: `/cooperativeShop/collaborateRules/viewRules`,
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped></style>
